// src/utils/statusColors.js

// Utility mapping for status to Bootstrap color classes
const statusColors = {
  active: "bg-success-subtle text-success",
  inactive: "bg-danger-subtle text-danger",
  success: "bg-success-subtle text-success",
  danger: "bg-danger-subtle text-danger",
  secondary: "bg-secondary text-white",
  orange: "bg-warning-subtle text-warning", // Light subtle orange shade
  teal: "bg-info-subtle text-info", // Eye-catching teal/blue shade
  info: "bg-info-subtle text-info", // For info badges

  // Add more status mappings as needed
};

export default statusColors;
